import { FlexProps } from 'vvs-uikit'
import styled from 'styled-components'
import { flexbox, layout, position, space, border } from 'styled-system'

type PixelatedImageProps = FlexProps & { grayout?: boolean; whenRetina?: boolean }

const PixelatedImage = styled.img<PixelatedImageProps>`
  ${({ whenRetina }) =>
    whenRetina
      ? `
    @media (min-resolution: 2dppx) {
      image-rendering: pixelated;
    }
  `
      : `
    image-rendering: pixelated;
  `}

  ${layout}
  ${position}
  ${space}
  ${flexbox}
  ${border}

  ${({ grayout }) =>
    grayout &&
    `
    filter: grayscale(1);
  `}
`

export default PixelatedImage
